// src/PlaidLinkButton.jsx
import { auth } from "./firebase";

const CREATE_URL =
  "https://us-central1-trelli-prod-473722.cloudfunctions.net/createLinkToken";
const EXCHANGE_URL =
  "https://us-central1-trelli-prod-473722.cloudfunctions.net/exchangePublicToken";

export default function PlaidLinkButton({
  onLinked,
  label = "Link an Account",
  mode = "create",     
  itemId = undefined,    
  daysRequested = 180,
  style = {},
  className = "",
}) {
  async function launchPlaidLink() {
    const user = auth.currentUser;
    if (!user) {
      alert("Please sign in first.");
      return;
    }

    const idToken = await user.getIdToken();

    const ALLOWED = [30, 90, 180];
    const days = ALLOWED.includes(Number(daysRequested)) ? Number(daysRequested) : 180;

    // 1) Request a link_token (send mode so functions can return update token if needed)
    const res = await fetch(CREATE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({ mode, itemId, daysRequested: days }),
    });

    if (!res.ok) {
      const msg = await res.text().catch(() => "Failed to create link token");
      console.error("createLinkToken failed:", msg);
      alert("Failed to start bank connection.");
      return;
    }

    const { link_token } = await res.json();

    sessionStorage.setItem("plaid_link_token", link_token);

    // 2) Open Plaid Link
    const handler = window.Plaid.create({
      token: link_token,
      onSuccess: async (public_token, metadata) => {
        sessionStorage.removeItem("plaid_link_token");
        try {
          const payload = {
            public_token,
            metadata,          // <-- pass institution, accounts, link_session_id, etc.
            mode,              // "create" or "update" (already a prop)
          };

          const exch = await fetch(EXCHANGE_URL, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${idToken}`,
            },
            body: JSON.stringify(payload),
          });

          if (!exch.ok) {
            const msg = await exch.text().catch(() => "Token exchange failed");
            console.error("exchangePublicToken failed:", msg);
            alert("Linked, but saving tokens failed.");
            return;
          }

          onLinked?.(); // let the UI refresh list(s)
          alert("✅ Bank connected! You’re good to go.");
        } catch (e) {
          console.error(e);
          alert("Unexpected error exchanging token.");
        }
      },
      onExit: (err) => {
        sessionStorage.removeItem("plaid_link_token");
        if (err) console.warn("Plaid exit with error:", err);
      },
    });

    handler.open();
  }

  const defaultStyle = {
    padding: "10px 16px",
    height: 40,            // helps match your toolbar button height
    lineHeight: "20px",
    backgroundColor: "#00B074",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontWeight: 600,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  };

  return (
    <button
      onClick={launchPlaidLink}
      className={className}
      style={{ ...defaultStyle, ...style }}
      type="button"
    >
      {label}
    </button>
  );
}